/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportDocDto } from '../../models/export-doc-dto';
import { ExportDocumentsModelDto } from '../../models/export-documents-model-dto';

export interface ExportDocumentsExportDocumentsDetail$Params {
  patientId?: string | null;
  practiceId?: string | null;
  patientName?: string | null;
  selectedPatientDataTypes?: string | null;
      body: ExportDocDto
}

export function exportDocumentsExportDocumentsDetail(http: HttpClient, rootUrl: string, params: ExportDocumentsExportDocumentsDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportDocumentsModelDto>> {
  const rb = new RequestBuilder(rootUrl, exportDocumentsExportDocumentsDetail.PATH, 'post');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('practiceId', params.practiceId, {});
    rb.query('patientName', params.patientName, {});
    rb.query('selectedPatientDataTypes', params.selectedPatientDataTypes, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportDocumentsModelDto>;
    })
  );
}

exportDocumentsExportDocumentsDetail.PATH = '/exportdocument/getExportDocuments';
